import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  FormGroup,
  ControlLabel,
  FormControl,
  Tooltip,
  OverlayTrigger
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";

class GeneralMemoList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedType: '',
      selectedCompany: ''
    }
  }

  handleActionSelect = (e) => {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value
    })
  }

  goToDetails = (id) => {
    this.props.history.push(`/general-memos/details/${id}`)
  }

  render() {

    const { selectedType, selectedCompany } = this.state;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;

    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <FormGroup controlId="formControlsSelect">
                <ControlLabel>Select Type</ControlLabel>
                <FormControl 
                    onChange={this.handleActionSelect}
                    componentClass="select" 
                    name="selectedType"
                    value={selectedType}
                  >
                  <option value="">Select</option>
                  <option value="employee">Employee</option>
                  <option value="product-dealer">Product Dealer</option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup controlId="formControlsSelect">
                <ControlLabel>Select Company</ControlLabel>
                <FormControl 
                    onChange={this.handleActionSelect}
                    componentClass="select" 
                    name="selectedCompany"
                    value={selectedCompany}
                  >
                  <option value="">Select</option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                title="General Memos"
                category="Here is a subtitle for this table"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Ref #</th>
                        <th>Subject</th>
                        <th>Recipient</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>08/11/2019</td>
                        <td>123456</td>
                        <td>3 OTs in a Month</td>
                        <td>John Doe</td>
                        <td className="td-actions text-right">
                            <OverlayTrigger placement="top" overlay={view}>
                              <CustomButtom 
                                bsStyle="success" 
                                simple 
                                type="button" 
                                bsSize="xs"
                                onClick={() => this.goToDetails('123456')}
                              >
                                <i className="fa fa-eye" />
                              </CustomButtom>
                            </OverlayTrigger>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default GeneralMemoList;
